import Vue from 'vue'

let evBus = new Vue()

export default {
  install: function (Vue) {
    Vue.prototype.$bus = evBus
  },
}
